define([
	"dojo/_base/declare",
	"csi/model/customView",
	"csi/table/Widget",
	"./SelectSetHelper"
], function(declare, {getCustomViewContainerKeyForType}, Widget, SelectSetHelper) {

	return declare(Widget, {
		/** @property {boolean} _bFirstLoad - indicates if loading view for first time */
		_bFirstLoad: true,

		/**
		 * @override
		 * Set target class of relationship
		 */
		setViewNode(node, bSaveSelections) {
			var type = SelectSetHelper.getItemTypeBySubtype(SelectSetHelper.getSubtypeName(this.getViewNode()));
			if (type) {
				this.relRoot.setType(type);
				this.prefKey = getCustomViewContainerKeyForType(type);
			}
			this.inherited(arguments);
		},

		/**
		 * @override
		 * Select all results when view is initially loaded
		 */
		_postView() {
			this.inherited(arguments);

			if (this._bFirstLoad) {
				this._bFirstLoad = false;

				setTimeout(() => {
					this.selectionCheckBox.set("value", true);
				}, 1);
			}
		}
	});
});